import { useEffect, useState } from 'react';
import { PageCard } from '../../components/page-card/PageCard';
import { useAuth } from '../../hooks/auth';
import IPage from '../../interfaces/IPage';
import { useLocalStorage } from '../../services/useLocalStorage';
import Iframe from 'react-iframe';

declare global {
  interface Window {
    AgentInitializer: any;
  }
}

const Home = (props: IPage) => {
  window.document.title = props.title;

  const { state } = useAuth();

  const localStorage = useLocalStorage();

  const [iFrameUrl, setIFrameUrl] = useState('');
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    const customization = localStorage.getItem('@PEDIDO-WEB:customization');
    setIFrameUrl(customization.iFrame);
  }, []);

  useEffect(() => {
    if (String(process.env.REACT_APP_JOTFOR).toLowerCase() === 'true') {
      const script = document.createElement('script');
      script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-embedded-agent.js';
      script.async = true;
      script.onload = () => {
        let attempts = 0;
        const maxAttempts = 50; // 5 segundos (50 * 100ms)
        const tryInit = () => {
          attempts++;
          if (window.AgentInitializer) {
            window.AgentInitializer.init({
              agentRenderURL: 'https://agent.jotform.com/0196a0326ee37810986891dc7c435fc21871',
              rootId: 'JotformAgent-0196a0326ee37810986891dc7c435fc21871',
              formID: '0196a0326ee37810986891dc7c435fc21871',
              queryParams: ['skipWelcome=1', 'maximizable=1'],
              domain: 'https://www.jotform.com',
              isDraggable: false,
              background: 'linear-gradient(180deg, #0F53B4 0%, #0F53B4 100%)',
              buttonBackgroundColor: '#246506',
              buttonIconColor: '#FFFFFF',
              variant: false,
              customizations: {
                greeting: 'Yes',
                greetingMessage: 'Olá! Como posso ajudá-lo?',
                openByDefault: 'No',
                pulse: 'Yes',
                position: 'left',
                autoOpenChatIn: '0',
              },
              isVoice: false,
            });
            window.localStorage.setItem('jotform-agent-injected', 'true');
          } else if (attempts < maxAttempts) {
            setTimeout(tryInit, 100);
          } else {
            console.error('Jotform AgentInitializer não foi encontrado após várias tentativas.');
          }
        };
        tryInit();
      };
      script.onerror = () => {
        console.error('Erro ao carregar o script do Jotform.');
      };
      document.body.appendChild(script);
    }
  }, []);

  return (
    <PageCard>
      <div style={{ height: '500px' }}>
        Seja bem vindo, <strong>{state.name}</strong>
      </div>
      {iFrameUrl && (
        <>
          <div style={{ height: '500px' }}>
            <Iframe url={iFrameUrl} height="100%" width="100%" title="iFrame" frameBorder={0}></Iframe>
          </div>
        </>
      )}
    </PageCard>
  );
};

export default Home;
